import type React from 'react';

import { List, ShowHide } from '@zillow/constellation-10';
import type { LandlordProvidedDocument } from '../../models/Types';

type Props = {
  landlordProvidedDocuments: Array<LandlordProvidedDocument>;
  showAsOrderedList: boolean;
  showIncludedText: boolean;
  hideExcessDocuments: boolean;
};

LandlordProvidedDocuments.defaultProps = {
  showAsOrderedList: true,
  showIncludedDocuments: false,
  hideExcessDocuments: false,
};

export default function LandlordProvidedDocuments({
  landlordProvidedDocuments,
  showAsOrderedList,
  showIncludedText,
  hideExcessDocuments,
}: Props): JSX.Element {
  function renderDocumentName(document: LandlordProvidedDocument): string {
    const { text, required, included } = document;

    if (required) {
      return `${text} (required)`;
    }
    return included && showIncludedText ? `${text} (included)` : text;
  }

  function renderList(): React.ReactNode {
    if (hideExcessDocuments && landlordProvidedDocuments.length > 3) {
      const firstThreeDocuments = landlordProvidedDocuments.slice(0, 3);
      const restOfTheDocuments = landlordProvidedDocuments.slice(3);

      return (
        <ShowHide.Root>
          <List.Root appearance={showAsOrderedList ? 'number' : 'bullet'} className="landlord-provided-documents">
            {firstThreeDocuments.map((document: LandlordProvidedDocument) => (
              <List.Item key={document.text}>{renderDocumentName(document)}</List.Item>
            ))}
            <ShowHide.Hidden>
              {restOfTheDocuments.map((document: LandlordProvidedDocument) => (
                <List.Item key={document.text}>{renderDocumentName(document)}</List.Item>
              ))}
            </ShowHide.Hidden>
          </List.Root>
        </ShowHide.Root>
      );
    }
    return (
      <List.Root appearance={showAsOrderedList ? 'number' : 'bullet'} className="landlord-provided-documents">
        {landlordProvidedDocuments.map((document: LandlordProvidedDocument) => (
          <List.Item key={document.text}>{renderDocumentName(document)}</List.Item>
        ))}
      </List.Root>
    );
  }

  return landlordProvidedDocuments && landlordProvidedDocuments.length > 0 ? <>{renderList()}</> : null;
}
